// useMerchants — TanStack Query hook for the admin merchant list.
//
// GET /v1/merchants is admin-only (RequireRole("admin")) — a non-admin caller
// gets 403. The query is therefore gated on the real JWT role so it never
// fires for merchant users. No per-merchant key — this is the global list.
import { useQuery } from "@tanstack/react-query";

import { listMerchants } from "@/api/merchants";
import { useAuth, isAdminRole } from "@/store/auth";

export function useMerchants() {
  const status = useAuth((s) => s.status);
  const isAdmin = useAuth((s) => isAdminRole(s.user?.role));

  return useQuery({
    queryKey: ["merchants"],
    queryFn: listMerchants,
    enabled: status === "authenticated" && isAdmin,
    staleTime: 60_000,
  });
}
